import React from "react";

import { pickValue } from "./utils";
import OnePanelChart from "./OnePanelChart";
import DivFormula from "./DivFormula";
import Text from "./Text";

const EarningsPerShare = ({ teams, competitionMetrics }) => (
  <OnePanelChart
    title="Earnings Per Share (EPS)"
    vertical
    prefix="$"
    data={pickValue(teams, competitionMetrics, "Earnings Per Share")}
    teams={teams}
  >
    <Text>
      EPS is a very common metric that investors track to evaluate the
      performance of a company and assess the value of owning a share of the
      company. Investors expect the EPS to grow over time.
    </Text>
    <DivFormula
      sm
      name1="EARNINGS PER SHARE (EPS)"
      name2="NET PROFITS"
      name3="AVERAGE SHARES OUTSTANDING"
    />
  </OnePanelChart>
);

export default EarningsPerShare;



// WEBPACK FOOTER //
// ./src/components/analysis/EarningsPerShare.js